import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Modal, Row, Col} from 'react-bootstrap';
import AddExclusivesForm from './AddExclusivesForm';
import * as courseActions from '../../actions/coursesActionCreators';
import label from '../../utils/lngEn';
// import config from '../../config';

class AddExclusivesModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      name: {
        value: '', style: null, message: ''
      },
      exclusive: {
        title: '',
        courseId:'',
        type: '',
        groupsArray: [],
        coursesArray: [],
        initialValues: {
        }
      },
      errorGroups: '',
      errorCourses: '',
      isSubmitting: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({exclusive: nextProps.initial});
  }

  handleSubmit(values) {
    this.setState({isSubmitting: true});
    let obj = { groups: [], coreqs: [] };
    if(values.group && typeof(values.group[0]) == 'object') {
      obj.groups = values.group.map(c => {
        return c.id;
      });
    } else {
      obj.groups = values.group || [];
    }
    if(values.courses && typeof(values.courses[0]) == 'object') {
      obj.coreqs = values.courses.map(c => {
        return c.id;
      });
    } else {
      obj.coreqs = values.courses || [];
    }
    let runName = localStorage.getItem('run');
    let url_add_update_exclusive = '/runs/'+runName+'/courses/'+this.state.exclusive.courseId+'/exclusives/', method = 'POST';
    if(values.id){
      url_add_update_exclusive = '/runs/'+runName+'/courses/'+this.state.exclusive.courseId+'/exclusives/' + values.id;
      method = 'PUT';
    }
    this.props.courseActions.addOrUpdateExclusive(url_add_update_exclusive, method, obj)
      .then((res) => {
        if(res){
          let objGroups = obj.groups.map(grp => {
            return { 'student_group': grp };
          });
        this.props.courseActions.addOrUpdateGroupsInExclusive(this.state.exclusive.courseId, res.id, objGroups)
          .then(() => {
            let objCoReqs = obj.coreqs.map(cor => {
              return { 'precond': cor };
            });
            this.props.courseActions.addOrUpdateCoReqsInExclusive(this.state.exclusive.courseId, res.id, objCoReqs)
              .then(() => {
                this.setState({isSubmitting: false});
                this.props.updateExclusives();
                this.props.closeModal();
              });
          });
        }
      });
  }

  render(){
    return (
      <Modal show={this.props.showModal} onHide={this.props.closeModal} backdrop="static" className="addConflictModal">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                {this.state.exclusive.title || label.addLock}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Enter the following information to create an Exclusive:</p>
          <AddExclusivesForm
            onSubmit={this.handleSubmit}
            onCancel={this.props.onCancel}
            initialValues={this.state.exclusive.initialValues}
            groupsArray={this.state.exclusive.groupsArray}
            coursesArray={this.state.exclusive.coursesArray}
            isSubmitting={this.state.isSubmitting}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

AddExclusivesModal.propTypes = {
  //myProp: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    group: state.group,
    student: state.student,
    courses: state.courses
  };
}

function mapDispatchToProps(dispatch) {
  return {
    courseActions: bindActionCreators(courseActions, dispatch)
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(AddExclusivesModal);



// WEBPACK FOOTER //
// ./src/components/classes/AddExclusivesModal.js